// extracted by mini-css-extract-plugin
module.exports = {"notifications":"_5D2CvfpB","error":"_5D10GloE","info":"_5D1q2fA9","success":"_5D1wKWC9","warning":"_5D3jrwF9"};